<template>
  <div class="point-analysis-item">
    <slot name="icon"></slot>
    <div v-if="title" class="title">{{ title }}</div>
    <div v-if="desc" class="desc">{{ desc }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped>
.point-analysis-item {
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #fff;
  width: 100%;
  padding: 16px;
  text-align: left;
}

.title {
  color: #1D2129;
  font-weight: 600;
  font-style: Semibold;
  font-size: 18px;
  margin-top: 16px;
  margin-bottom: 8px;
}

.desc {
  color: #50627F;
  font-weight: 400;
  font-size: 16px;
  line-height: 170%;
}

@media screen and (max-width: 1000px) {
  .title {
    font-size: 16px;
    margin-top: 8px;
  }

  .desc {
    font-size: 14px;
  }

  svg {
    width: 24px !important;
    height: 24px !important;
  }
}
</style>